var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2",staticStyle:{"position":"fixed","bottom":"0","right":"0","z-index":"4"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }